import { render, staticRenderFns } from "./ProfileTierName.vue?vue&type=template&id=0e5b2ca0&scoped=true&"
import script from "./ProfileTierName.vue?vue&type=script&lang=js&"
export * from "./ProfileTierName.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTierName.vue?vue&type=style&index=0&id=0e5b2ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b2ca0",
  null
  
)

export default component.exports